const userHu = {
	userTable: 'Access',
	name: 'Name',
	roles: 'Roles',
	email: 'E-mail',
	registrationTimestamp: 'Registration Time',
	lastLoginTimestamp: 'Last Login Time',
	registrationStatus: 'Enabled',
	dashboardRoleTable: 'Role',
	title: 'Name',
	adminDescription: 'Description',
	isEnabled: 'Enabled',
	created: 'Created',
	updated: 'Updated',
	dashboardRoleEditForm: 'Role',
	basic: 'Basic',
	servicePermissionList: 'Service Permissions',
	contentPermissionList: 'Content Permissions',
	key: 'Name used by System (optional)',
	orderIndex: 'Position',
	isSuperAdmin: 'Superadmin',
	service: 'Service',
	grantedLevel: 'Grant Level',
	contentType: 'Content Type',
	userGroups: 'User Groups'
};

export default userHu;
